export default "/images/vendor/flag-icon-css/flags/4x3/bl.svg?6a6bc7f183b774316b63325b5e8ae296";